import type { FC } from 'react';
import React from 'react';
import cn from 'classnames';

import type { TBackgroundV2 } from '../models';

export const BackgroundV2: FC<React.PropsWithChildren<TBackgroundV2>> = ({
    borderRadius,
    children,
    className,
    color,
    dataTestId,
    gradient,
    gradientOverImage,
    gradientUnderImage,
    image,
    styles,
}) => {
    const gradientOver = gradientOverImage ? `${gradientOverImage},` : '';
    const gradientUnder = gradientUnderImage ? `,${gradientUnderImage}` : '';

    const backgroundImage = image && `${gradientOver}url(${image})${gradientUnder}`;
    const currentBackground = backgroundImage || gradient || undefined;

    return (
        <div
            className={cn(styles.responsiveBackground, className)}
            data-test-id={dataTestId}
            style={{
                backgroundImage: currentBackground,
                backgroundColor: color,
                borderRadius,
            }}
        >
            {children}
        </div>
    );
};
